import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { imageInsSlice } from "../../../redux/image/imageInsSlice";
import { ElementUploadImage } from "../../../features/base/image/ElementUploadImage";
import ElementSkeleton from "../../../features/base/ElementSkeleton";
import DptoPageTitle from "../basics/DptoPageTitle";
import DptoPageAvatar from "../basics/DptoPageAvatar";
import { dptoSlice, selectDpto } from "../../../redux/dpto/dptoSlice";
import { routeDpto } from "../../../routes/dpto";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { ObjectTarget } from "../../../app/permissions";
import { assertThumbnailUrl } from "../../../redux/common";
import { TopBar } from "../../../features/top/TopBar";

export function DptoImage() {
    const school = useSelector(selectSchool);
    const dpto = useSelector(selectDpto);
    const dispatch = useAppDispatch();

    const {schoolId, dptoId} = useParams();
    console.debug(`SchoolImage: ${schoolId}, Dpto: ${dptoId}`);
    if(!schoolId || !dptoId) {
        return <ElementMissingContext />;
    }

    const breadcrumbTitle = "Alterar Imagem";
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const title = <DptoPageTitle schoolId={schoolId} dptoId={dptoId} />;
    const pageAvatar = <DptoPageAvatar />;
  
    const buildContent = () =>
        (dpto.selected)
        ? <ElementUploadImage 
              currentImage={assertThumbnailUrl(dpto.selected.url)}
              name={dpto.selected.name}
              backTo={routeDpto(schoolId, dptoId)}
              target={{schoolId: schoolId, avatar: true, objectTarget: ObjectTarget.DPTO, targetId: dptoId}}
              backCleanup={() => {
                dispatch(schoolSlice.actions.clean());
                dispatch(dptoSlice.actions.clean());
                dispatch(imageInsSlice.actions.clean());
              }}
          />
        : <ElementSkeleton />
      ;

    return <PageAuthenticatedLoading key="dptoImage"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
            states: [school.state, dpto.state], 
            content: buildContent,
            error: "Erro ao carregar departamento",
            retry: () => {
            dispatch(schoolSlice.actions.clean());
            },
        }}
    />;
                
}
